import { render, staticRenderFns } from "./bloodTrend.vue?vue&type=template&id=8e2ff9ba&scoped=true&"
import script from "./bloodTrend.vue?vue&type=script&lang=js&"
export * from "./bloodTrend.vue?vue&type=script&lang=js&"
import style0 from "./bloodTrend.vue?vue&type=style&index=0&id=8e2ff9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2ff9ba",
  null
  
)

export default component.exports